import { useTheme } from "@emotion/react";
import {
  Grid,
  Box,
  Typography,
  Divider,
  Card,
  Button,
  Link,
  useMediaQuery,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";

const Footer = () => {
  const theme = useTheme();
  const mediumScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Grid
      container
      id="contact"
      style={{ backgroundColor: theme.palette.primary.main }}
      direction={mediumScreen ? "" : "column-reverse"}
    >
      <Grid item md={4} xs={12} display="flex" position="relative">
        <Box
          style={{
            // background:
            //     "radial-gradient(circle, rgba(7,129,160,1) 0%, rgba(2,66,94,1) 87%, rgba(2,66,94,1) 100%, rgba(2,66,94,1) 100%)",
            background: "rgb(0 42 115)",
            width: "100%",
            borderRadius: "0px 10% 0px 0px",
          }}
          pt={6}
        >
          <Grid
            item
            xs={10}
            md={9}
            mx={"auto"}
            sx={{
              mb: { xs: 3, md: 0 },
              textAlign: { xs: "center", md: "start" },
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/img/nex-logo-white.png"}
              style={{ width: 180 }}
              alt="logo"
            ></img>
          </Grid>
          <Grid
            item
            xs={10}
            md={9}
            sx={{
              position: { xs: "relative", md: "absolute" },
            }}
            bottom={0}
            left={0}
            right={0}
            mx={"auto"}
          >
            <Box>
              <Box
                display={"flex"}
                alignItems="center"
                gap={1}
                py={3}
                sx={{
                  justifyContent: { xs: "center", md: "start" },
                }}
              >
                <FacebookIcon fontSize={"large"} color={"white"} />
                <Typography variant={"h6"}>
                  <Link
                    href="https://www.facebook.com/profile.php?id=100089584077868&mibextid=ZbWKwL"
                    style={{
                      color: theme.palette.white.main,
                      fontWeight: "normal",
                    }}
                  >
                    NEX'S FACEBOOK
                  </Link>
                </Typography>
              </Box>
              <Divider style={{ backgroundColor: "white" }}></Divider>
              <Typography
                variant="body2"
                style={{ color: theme.palette.white.main }}
                py={3}
                sx={{
                  textAlign: { xs: "center", md: "start" },
                }}
              >
                NEXSOLUTIONS © 2023
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Grid>
      <Grid
        item
        md={8}
        sx={{
          px: { xs: 3, md: 4 },
        }}
        py={4}
      >
        <Grid container spacing={4}>
          <Grid item md={6} xs={12} display="flex">
            <Card>
              <Box p={5}>
                <Typography variant={"caption"}>FREE CONSULTATION</Typography>
                <Typography variant="h5" fontWeight={600}>
                  Begin Your Adventure With Experienced Professionals
                </Typography>
                <Box mt={10}>
                  <Button variant="contained">
                    <Link
                      href="https://www.facebook.com/profile.php?id=100089584077868"
                      color="inherit"
                      target="_blank"
                      underline="none"
                    >
                      Join with our Team
                    </Link>
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item md={6} xs={12} display="flex">
            <Card>
              <Box p={5}>
                <Typography variant={"caption"}>HELP DESK</Typography>
                <Typography variant="h5" fontWeight={600}>
                  Do You Have Questions Or Want More Information? Call us now!
                </Typography>
                <Typography variant="h5" mt={1}>
                  <Link href="tel:+66971258531" target="_blank">
                    (+66) 971258531
                  </Link>
                </Typography>
                <Typography mt={1}>hi.nexsolutions@gmail.com</Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Footer;
